import { createAction } from '@reduxjs/toolkit';

import {
  TicketAssistWithArticleEvent,
  TicketResolutionExitEvent,
  TicketResolutionStartEvent,
  TicketResolvedEvent,
} from '../analytics/events';
import {
  SetNoSolutionDraftArticlePayload,
  SetNoSolutionDraftArticleSubmittedPayload,
  SetNoSolutionSubmittedPayload,
  SetResolutionArticleContentPayload,
  SetResolutionArticleIdPayload,
  SetResolutionArticleIdsPayload,
  SetResolutionDraftNotesPayload,
  SetResolutionDraftQuestionPayload,
  SetResolutionInputValuePayload,
  SetResolutionSearchTermPayload,
} from '../types/elevio.actions';

const prefix = `elevio/resolution`;

export const resolutionActions = {
  ticketResolved: createAction<TicketResolvedEvent>(`${prefix}/ticketResolved`),
  initiateResolutionPrompt: createAction<TicketResolutionStartEvent>(
    `${prefix}/initiateResolutionPrompt`,
  ),
  setSolution: createAction<{ searchInputValue: string }>(
    `${prefix}/setSolution`,
  ),
  setSolutionDropdownOpen: createAction(`${prefix}/setSolutionDropdownOpen`),
  setSolutionDropdownClosed: createAction(
    `${prefix}/setSolutionDropdownClosed`,
  ),
  debouncedSetSolutionDropdownClosed: createAction(
    // debounced to prevent rapid closing of dropdown, see Saga notes for details
    `${prefix}/debouncedSetSolutionDropdownClosed`,
  ),
  setSolutionSubmitted: createAction<TicketAssistWithArticleEvent>(
    `${prefix}/setSolutionSubmitted`,
  ),

  // Cancellation flow
  setCancelWarning: createAction(`${prefix}/setCancelWarning`), // For showing a confirmation dialog before user finally quits out of resolution flow
  unsetCancelWarning: createAction(`${prefix}/unsetCancelWarning`), // For undoing a cancel warning and going back to the previous state
  setNoSolution: createAction(`${prefix}/setNoSolution`),
  setNoSolutionNoDraftArticle: createAction(
    `${prefix}/setNoSolutionNoDraftArticle`,
  ),
  setNoSolutionSubmitted: createAction<SetNoSolutionSubmittedPayload>(
    `${prefix}/setNoSolutionSubmitted`,
  ),
  setNoSolutionDraftArticle: createAction<SetNoSolutionDraftArticlePayload>(
    `${prefix}/setNoSolutionDraftArticle`,
  ),
  setNoSolutionDraftArticleSubmitted:
    createAction<SetNoSolutionDraftArticleSubmittedPayload>(
      `${prefix}/setNoSolutionDraftArticleSubmitted`,
    ),
  setResolutionArticleId: createAction<SetResolutionArticleIdPayload>(
    `${prefix}/setResolutionArticleId`,
  ),
  unsetResolutionArticleId: createAction(`${prefix}/unsetResolutionArticleId`),
  setResolutionDraftQuestion: createAction<SetResolutionDraftQuestionPayload>(
    `${prefix}/setResolutionDraftQuestion`,
  ),
  setResolutionDraftNotes: createAction<SetResolutionDraftNotesPayload>(
    `${prefix}/setResolutionDraftNotes`,
  ),
  setResolutionArticleIds: createAction<SetResolutionArticleIdsPayload>(
    `${prefix}/setResolutionArticleIds`,
  ),
  setResolutionInputValue: createAction<SetResolutionInputValuePayload>(
    `${prefix}/setResolutionInputValue`,
  ),
  setResolutionSearchTerm: createAction<SetResolutionSearchTermPayload>(
    `${prefix}/setResolutionSearchTerm`,
  ),
  setResolutionArticleContent: createAction<SetResolutionArticleContentPayload>(
    `${prefix}/setResolutionArticleContent`,
  ),
  // Exited resolution flow early
  ticketResolutionExited: createAction<TicketResolutionExitEvent>(
    `${prefix}/ticketResolutionExited`,
  ),
};
